import { $ } from "../shared/globals.js";

export function createMenuTigerWalkFeature({ CONFIG, prefersReducedMotion }) {
    const $menuTigerWalk = $(".menu-tiger-walk");
    const $menuTigerStatic = $menuTigerWalk.find(".menu-tiger-static");
    const $menuTigerFrames = $menuTigerWalk.find(".menu-tiger-frame");
    const totalFrames = CONFIG.tigerWalkFrames;

    let tigerWalkInterval = null;
    let tigerWalkTimeout = null;
    let currentTigerFrame = 1;
    let tigerWalkingEnabled = false;

    function showFrame(frameNumber) {
        $menuTigerFrames.removeClass("active");
        $menuTigerWalk.find(`.menu-tiger-frame-${frameNumber}`).addClass("active");
    }

    function runWalkCycle() {
        if (!tigerWalkingEnabled) return;

        tigerWalkInterval = window.setInterval(() => {
            currentTigerFrame += 1;

            if (currentTigerFrame > totalFrames) {
                currentTigerFrame = 1;
                window.clearInterval(tigerWalkInterval);
                tigerWalkInterval = null;
                showFrame(currentTigerFrame);

                tigerWalkTimeout = window.setTimeout(() => {
                    if (tigerWalkingEnabled) {
                        runWalkCycle();
                    }
                }, CONFIG.tigerWalkPauseDuration);

                return;
            }

            showFrame(currentTigerFrame);
        }, CONFIG.tigerWalkFrameRate);
    }

    function start() {
        if (!$menuTigerWalk.length || !$menuTigerFrames.length || tigerWalkingEnabled) return;

        if (prefersReducedMotion) {
            $menuTigerStatic.addClass("active");
            return;
        }

        tigerWalkingEnabled = true;
        currentTigerFrame = 1;
        $menuTigerStatic.removeClass("active");
        showFrame(currentTigerFrame);
        runWalkCycle();
    }

    function stop() {
        if (tigerWalkInterval) {
            window.clearInterval(tigerWalkInterval);
            tigerWalkInterval = null;
        }

        if (tigerWalkTimeout) {
            window.clearTimeout(tigerWalkTimeout);
            tigerWalkTimeout = null;
        }

        tigerWalkingEnabled = false;
        currentTigerFrame = 1;
        $menuTigerFrames.removeClass("active");
        $menuTigerStatic.addClass("active");
    }

    return {
        start,
        stop,
    };
}
